import { FC } from 'react'
import { MdChevronLeft } from 'react-icons/md'
import { useLogisticBox } from '../context/LogisticBoxContext'
import { LogisticBoxView } from '../models'

interface Props {
  to: LogisticBoxView
  label?: string
}

const BackButton: FC<Props> = ({ to, label = 'Volver' }) => {
  const { setActiveView } = useLogisticBox()
  return (
    <button
      onClick={() => setActiveView(to)}
      className='inline-flex items-center gap-1 text-sm font-medium text-[#151930]/70 hover:text-[#151930] transition-colors'
    >
      <MdChevronLeft className='text-lg' />
      {label}
    </button>
  )
}

export default BackButton
